import React, { Component } from 'react';
import PopUp from '../../../../commonModules/interface/PopUp';
import InputText, { InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { toast } from 'react-toastify';
import Dialog from '../../../../commonModules/interface/Dialog';
import axios from 'axios';
import CheckProductList from './CheckProductList';
import { isEmpty } from 'lodash-es';

class AddStockInStorage extends Component {
    state = {  
        quantity: this.props.pItem.quantity,
        selectedProducts: []
    }
    // const [selectedProducts, setSelectedProducts] = useState([]);

    // const handleSelectedProducts = (selectedList) => {
    //   setSelectedProducts(selectedList);
    // };
    handleSelectedProducts = (selectedProducts) => {
      this.setState({selectedProducts});
    };
    validate = () => {
        const { pItem } = this.props;
        // check if quantity > 0 && < pItem.rest_quantity
        // if (this.state.quantity > 0 && this.state.quantity <= pItem.quantity) { // TODO rest to stock
        if (!isEmpty(this.state.selectedProducts)) {
            this.handleSubmit()
        } else {
            toast.error("Qunatité invalide")
        }

    }
    handleSubmit = async () => {
        let data = {
            block_id: this.props.block.id,
            RFID_list: this.state.selectedProducts,
            purchase_item_id: this.props.pItem.id,
            // quantity: parseInt(this.state.quantity)
        }

        let res = await axios.post("/stocks/addData", {
            page: "local/add/stock",
            data: data
        }) 
        if(res.data.error){
            console.log("ERROR", res.data.error);
            this.setState({
                sending: false,
            })
            let errorMessage = "Une erreur est survenue";
            if (typeof res.data.error === 'string') {
                errorMessage = res.data.error;
            } else if (res.data.error && typeof res.data.error === 'object') {
                errorMessage = res.data.error.message || res.data.error.error || JSON.stringify(res.data.error);
            }
            toast.error(errorMessage)
        } else{
            console.log("fetched");
            //success 
            this.setState({
                sending: false,
            })
            toast.info("Opération enregistrée avec succès")
            // this.props.filterList(undefined, undefined)
            // this.props.handleClose()
        }   

    }
    render() {
        console.log('====================================');
        console.log(this.props);
        console.log('====================================');
        return (
            <Dialog
                appbar
                close={this.props.handleClose}
                title={`Ajouter du stock dans ${this.props.block.storage_name}`}
                submitAction={this.validate}
                maxWidth="lg"
                block={true}
            >   
                {/* 1. Find all purchase from this shop */}
                {/* 2 Make a select list of all available products */}
                {/* 3 + Select date purchase + quantity field */}
                {/* quantity */}
                
                {/* <InputText
                    label="Quantité"
                    name="quantity"
                    type="number"
                    required
                    onChange={(e) => this.setState({ quantity: e.target.value })}
                /> */}
                {/* <InputText
                    label="RFID"
                    name="rfid"
                    // required
                    // onChange={(e) => this.setState({ R: e.target.value })}
                /> */}
                <CheckProductList
                    products={this.props.pItem}
                    onSelectedProductsChange={this.handleSelectedProducts}
                />
            </Dialog>
        );
    }
}

export default AddStockInStorage;
